import React, { Component } from 'react';
import { startIdentityAuth } from '@riotgames/kr-identity-sdk';
import { Button, ButtonType, Spinner } from '@riotgames/accounts-react-components';
import AppContext from '../AppContext';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

import cx from 'classnames';
import { Grid, GridAlignment, GridDirection, GridJustify } from '@riotgames/accounts-react-components/lib/Grid';
import { GridPanel } from '@riotgames/accounts-react-components/lib/Grid/GridPanel';

const VALID_AUTHCALLBACK_PATH = '/auth';

class SelfAuth extends Component {
  static contextType = AppContext;

  state = {
    shouldWaitForVerifiedAuth: false,
    isVerifiedAuth: false
  };

  async componentDidMount() {
    this.callbackAuth(this.props.location);
  }

  update(params) {
    const { actions } = this.context;
    actions.setData(params);
  }

  async updateFlow() {
    const {
      actions: { setFlow },
      state: { age }
    } = this.context;

    const isMinor = age < 18;

    return setFlow(isMinor);
  }

  moveNext = () => {
    this.props.handleMoveNext();
  };

  async callbackAuth(location) {
    const authToken = this.getAuthToken(location);

    if (authToken) {
      this.setState({ shouldWaitForVerifiedAuth: true });

      const verifiedPI = await this.onVerified(authToken);
      const isConfirmedAge = this.confirmAge(verifiedPI.age);

      if (!isConfirmedAge) {
        return this.update({
          hasError: true,
          shouldReset: true,
          errorDetail: '만 12세 미만은 가입하실 수 없습니다.'
        });
      }

      const hasBannedStatus = await this.hasBannedStatus();
      if (hasBannedStatus) {
        return this.update({
          hasError: true,
          shouldReset: true,
          errorHeader: '영구 제재 알림',
          errorDetail:
            '하나 이상의 게임에서 영구 제재 내역이 있습니다. 라이엇 계정으로 변환이 불가능하며, 계정 생성하기를 통한 회원가입은 가능합니다.'
        });
      }

      this.setState({ isVerifiedAuth: isConfirmedAge, shouldWaitForVerifiedAuth: false });

      await this.fetchRestrictedGames(authToken);
      await this.updateFlow();

      this.props.history.replace('/'); // location replace to '/' for removing callback path and token
    }
  }

  getAuthToken = (location) => {
    const isValidPath = location.pathname === VALID_AUTHCALLBACK_PATH;
    const token = queryString.parse(location.search).result;

    return isValidPath && !!token && token;
  };

  confirmAge(age) {
    return age >= 12;
  }

  async hasBannedStatus() {
    const {
      state: { signupType },
      actions: { getAccountList }
    } = this.context;

    if (signupType !== 'PROMOTION') {
      return false;
    }

    const { data } = await getAccountList();
    const { gameRestricted } = data;

    return gameRestricted;
  }

  async fetchRestrictedGames(authToken) {
    const {
      actions: { getRestrictedGames }
    } = this.context;

    try {
      const { data } = await getRestrictedGames(authToken);
      const notAvailableGames = data.filter((game) => game.restricted === true);

      return this.update({
        restrictedGames: notAvailableGames
      });
    } catch (e) {
      this.update({
        hasError: true,
        shouldReset: true,
        errorDetail: '인증 실행 과정에서 오류가 발생되었습니다. 재인증 해주시기 바랍니다.'
      });
    }
  }

  onVerified = async (authToken) => {
    const {
      actions: { acquirePI, setData }
    } = this.context;

    try {
      const { data } = await acquirePI(authToken);
      setData({
        age: data.age,
        realName: data.realName,
        birthDate: data.birthDate,
        govtId: data.govtId,
        playerAuthInfo: authToken
      });

      return data;
    } catch (e) {
      this.update({
        hasError: true,
        shouldReset: true,
        errorDetail: '인증 실행 과정에서 오류가 발생되었습니다. 재인증 해주시기 바랍니다.'
      });
    }
  };

  handleSelfAuth = (e) => {
    const {
      state: { identity }
    } = this.context;
    const { identityCode, env } = identity;
    const callbackUrlPort = location.port ? `:${location.port}` : '';
    const callbackUrlHost = `${location.protocol}//${location.hostname}${callbackUrlPort}`;

    startIdentityAuth({
      serviceType: identityCode,
      environment: env,
      isPopup: false,
      callbackUrl: `${callbackUrlHost}/auth?result={}`
    });
  };

  render() {
    const { isVerifiedAuth, shouldWaitForVerifiedAuth } = this.state;
    const {
      state: { signupType }
    } = this.context;

    const signupTypeString = signupType === 'PROMOTION' ? '업그레이드를' : '회원가입을';
    const subTitlePanel = !isVerifiedAuth ? (
      <p className="help-text">
        {signupTypeString} 위한 본인인증이 필요합니다. <br />
        본인인증 시 제공되는 정보는 해당 인증기관에서 직접 수집하며, 인증 이외의 용도로 이용 또는 저장하지 않습니다.
      </p>
    ) : (
      <p className="help-text">본인인증이 완료 되었습니다.</p>
    );

    const submitButton = !isVerifiedAuth ? (
      <Button buttonType={ButtonType.primary} label="본인인증하기" onClick={this.handleSelfAuth} />
    ) : (
      <Button buttonType={ButtonType.submit} disabled={!isVerifiedAuth} onClick={this.moveNext} />
    );

    return (
      <GridPanel title={'본인인증'} subTitle={!shouldWaitForVerifiedAuth && subTitlePanel} button={submitButton}>
        <Grid
          direction={GridDirection.vertical}
          align={GridAlignment.center}
          justify={GridJustify.spaceBetween}
          fill={true}
        >
          {shouldWaitForVerifiedAuth && <Spinner />}
        </Grid>
      </GridPanel>
    );
  }
}

export default withRouter(SelfAuth);
